module.exports = __webpack_public_path__ + "media/images/yardstick-ruler-green-74c102f2f1d762fdf22179c433d38344.png";